(() => {
  angular.module('app').component('hostClaimPolicyComponent', {
    templateUrl: require('./claimPolicy.component.html'),
    controller: ClaimPolicyController,
    controllerAs: 'vm',
    bindings: {
      memberId: '<',
      isInpatient: '<',
    }
  });

  ClaimPolicyController.$inject = [
    'abp.services.app.commonLookup', 'Hms.Employees.IdentificationType'
  ];

  function ClaimPolicyController(
    commonLookupSvc, enumIdentificationType
  ) {
    const vm = this;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.loading = 0;

    vm.scrollContentToTop = scrollContentToTop;

    vm.enums = {};
    vm.enums.identificationType = enumIdentificationType;

    vm.isInpatient = vm.isInpatient || false;

    /* Functions */

    function init() {
      getClaimPolicy();
    }

    function getClaimPolicy() {
      vm.loading += 1;
      commonLookupSvc.getMemberClaimPolicy(
        { memberId: vm.memberId, isInpatient: vm.isInpatient })
        .success((data) => {
          vm.data = data;
        }).finally(() => {
          vm.loading -= 1;
        });
    }

    function scrollContentToTop() {
      $('#policyContent').scrollTop(0);
    }

    /* End of Functions */

    init();
  }

})();
